import prominentExpandedTpl from 'templates/carousels/highlightCarousel/expandingContainer.tpl';
import { ProminentDefaultBreakpointRules } from 'components/settings/BreakpointSettings';
import { trackAction } from 'helpers/trackingOM';
import HighlightCarousel from './HighlightCarousel';
import { calculatePosition } from '../helpers';
import MediaManager from 'components/highlight/MediaManager';

class ProminentCarousel extends HighlightCarousel {
    constructor(element, options) {
        super(element, options);
        this.type = 'prominent';
        this.element = element;
        this.template = prominentExpandedTpl;
    }

    __preloadImage(elementData) {
        const url = elementData.expandedBackgroundImage;
        if (url) {
            new Image().src = url;
        }
    }

    __expandElement(carouselElement, expandedElement) {
        const growthRate = 1.11;
        const aspectRatio = 4 / 5;
        const initial = carouselElement.getBoundingClientRect();
        const expandedHeight = initial.height * growthRate;
        const expandedWidth = expandedHeight * aspectRatio;

        expandedElement.style.display = 'block';

        let positionObj = calculatePosition(
            carouselElement,
            expandedWidth,
            expandedHeight,
            this.expandedElement,
        );

        Object.assign(expandedElement.style, positionObj);

        expandedElement.style.width = `${expandedWidth}px`;
        expandedElement.style.height = `${expandedHeight}px`;
        expandedElement.style.opacity = 1;

        trackAction(
            'trackCarouselExpanded',
            this.__getTrackingSpecs(carouselElement, expandedElement),
        );

        // wait for element to expand partially to avoid text scrolling issues
        setTimeout(() => {
            if (this.expandedElement) {
                this.expandedElement.querySelector(
                    '.prominent-expanded-overlay-components',
                ).style.opacity = 1;
            }
        }, 200);

        expandedElement.addEventListener('mouseleave', () => {
            this.__removeExpandedElement(carouselElement);
        });
    }

    __createMediaManager(data, target) {
        let carouselId = this.element?.closest('.carousel')?.getAttribute('data-displayId');
        carouselId = carouselId ?? '';
        const previewContainer = `prominent_${carouselId}_${data.videoContentId}`;

        const mediaManagerOptions = {
            target,
            videoLogoUrl: data.titleLogo,
            imageUrl: data.expandedBackgroundImage,
            fallbackText: data.titleText,
            altImage: data.alt,
            videoContentId: data.videoContentId,
            hlsVideoUrl: data.videoPreviewURL ?? '',
            previewContainer,
        };

        this.mediaManager = new MediaManager(mediaManagerOptions);

        this.mediaManager.addClass('prominent');
        this.mediaManager.addClass('standby');
        this.mediaManager.showVideoOverlayCallback = () => {
            this.mediaManager.removeClass('standby');
        };

        target.parentElement
            .querySelector('.prominent-expanded-overlay-components')
            .prepend(this.mediaManager.overlayContainer);
    }

    manageOnEndedCallback(carouselElement, expandedElement) {
        this.mediaManager.onEndedCallback = () => {
            const track = this.__getVideoTracking(
                carouselElement,
                expandedElement,
                this.mediaManager.video,
            );
            trackAction('trackVideoPreviewEnd', track);
            this.mediaManager.addClass('standby');
        };
    }
}

export default function (customOptions = {}) {
    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');

    let defaultOptions = {
        responsive: ProminentDefaultBreakpointRules,
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);

    new ProminentCarousel(wrapper, endOptions);
}
